module.exports = __webpack_public_path__ + "img/typesetting_20pt_checked.e414c02a.svg";